import { AppCustomResponse } from '@models/custom';
import { createContext } from 'react';

export interface AppCustomContextProps {
    response: AppCustomResponse
}

const AppCustomContext = createContext<AppCustomContextProps>({} as AppCustomContextProps);

export default AppCustomContext;
